import { render } from "./MoreLinks.vue?vue&type=template&id=1550d502&scoped=true"
import script from "./MoreLinks.vue?vue&type=script&lang=js"
export * from "./MoreLinks.vue?vue&type=script&lang=js"

import "./MoreLinks.vue?vue&type=style&index=0&id=1550d502&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1550d502"]])

export default __exports__